import { Base64 } from '@js-sdk/encoding';
export function createProtectedManifest(options) {
    const segments = options.segments.map((segment) => `#EXTINF:${segment.duration},
${segment.url}`);
    const extKey = options.assetID
        ? `#EXT-X-KEY:METHOD=SAMPLE-AES,URI="skd://${options.assetID}",KEYFORMATVERSIONS="1",KEYFORMAT="com.apple.streamingkeydelivery"`
        : '';
    return `#EXTM3U
#EXT-X-VERSION:6
#EXT-X-TARGETDURATION:${Math.floor(options.targetDuration)}
#EXT-X-PLAYLIST-TYPE:VOD
${extKey}
${segments.join('\n')}
#EXT-X-ENDLIST`;
}
export function createHLSDataURL(manifest) {
    return `data:application/vnd.apple.mpegurl;base64,${Base64.encode(manifest)}`;
}
export function createProtectedManifestURL(options) {
    const manifest = createProtectedManifest(options);
    return createHLSDataURL(manifest);
}
//# sourceMappingURL=hls.js.map